const SESSION_KEY_PREFIX = 'frm_upload_session';
const SESSION_REGEX = /^[A-Za-z0-9_-]{8,64}$/;

const randomSegment = () => {
	if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
		const bytes = new Uint8Array(6);
		window.crypto.getRandomValues(bytes);
		return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
	}

	return Math.random().toString(36).slice(2, 14);
};

const createUploadSession = () => {
	return `${Date.now().toString(36)}_${randomSegment()}`;
};

const getStorageKey = (config) => {
	const formId = Number(config?.formID) || 0;
	const fieldId = Number(config?.fieldID) || 0;
	return `${SESSION_KEY_PREFIX}:${formId}:${fieldId}`;
};

export const getOrCreateUploadSession = (config = {}) => {
	const storageKey = getStorageKey(config);

	try {
		const existingSession = window.sessionStorage.getItem(storageKey);
		if (existingSession && SESSION_REGEX.test(existingSession)) {
			return existingSession;
		}

		const nextSession = createUploadSession();
		window.sessionStorage.setItem(storageKey, nextSession);
		return nextSession;
	} catch {
		return createUploadSession();
	}
};
